<script>
  /* Executable code section of the program */
  //Tools importation
  import {
    updateDocument,
    updateLocalData,
  } from "../../apis/APIS";
  import { alertMessagge, isAlertOn, isReloadNecessary, userLocalData,userRealTime } from "../../apis/storage";
  import { presetName, cloudName } from "../../apis/config";
  import { onMount } from "svelte";
  import AlertModal from "../../components/Modals/AlertModal.svelte";

  //Auxiliary Variables
  $: dinamicImage = "";

  //function to display alert
  const displayAlert = () =>{
    $isAlertOn = true
  }

  //Function to post-image
  export const uploadImage = async (e) => {
    //definicion de variables de acceso
    const preset_name = presetName;
    const cloud_name = cloudName;

    //Obtencion de la imagen
    const files = e.target.files;
    const data = new FormData();
    data.append("file", files[0]);
    data.append("upload_preset", preset_name);

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
        {
          method: "POST",
          body: data,
        }
      );

      const file = await response.json();
      dinamicImage = file.secure_url;
      $userLocalData[0].profileImgUrl = file.secure_url;
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  //Function to update data
  const updateData = () => {
    if (
      $userRealTime.name === "" ||
      $userRealTime.surname == "" ||
      $userRealTime.country == "" ||
      $userRealTime.jobtittle == "" ||
      $userRealTime.company == ""
    ) {
      $isAlertOn = true
      $alertMessagge = "No field can be left empty."
      displayAlert()
    } else {

      //updating local data
      //updating firebase data
      updateDocument("users", $userRealTime, $userRealTime.id).then(()=>{
        $isAlertOn = true
            $alertMessagge = "Your profile has been successfully updated in the system."
          $isReloadNecessary = true
            displayAlert()
          })
          .catch(()=>{
          $alertMessagge = "An error occurred while updating the profile";
          displayAlert()
          })
    }
  };

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    $userRealTime = $userLocalData[0]
    dinamicImage = $userLocalData[0].profileImgUrl
    
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<div class="PrincipalContainer">
  <div class="imgContainer">
    <div class="updateImageContainer">
      <label for="image" class="editBtnContainer">
        <input
          type="file"
          id="image"
          name="image"
          style="display: none;"
          on:change={(e) => uploadImage(e)}
        />
        <span class="btnInput">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
            />
          </svg>
        </span>
      </label>
    </div>
    {#if $userLocalData[0].profileImgUrl === "" || $userLocalData[0].profileImgUrl == undefined}
      <div class="circle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="90"
          height="90"
          fill="currentColor"
          class="bi bi-person icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"
          />
        </svg>
      </div>
    {:else}
      <img src={dinamicImage} alt="AvatarImage" />
    {/if}
  </div>
  <div class="infoContainer">
    <div class="containerInputs">
      <div class="form-floating">
        <input
          type="text"
          class="form-control floatingPassword"
          placeholder="Tittle Event"
          bind:value={$userRealTime.name}
        />
        <label for="floatingPassword">Name*</label>
        <br />
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control floatingPassword"
          placeholder="Country"
          bind:value={$userRealTime.surname}
        />
        <label for="floatingPassword">Surname*</label>
        <br />
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control floatingPassword"
          placeholder="Country"
          bind:value={$userRealTime.country}
        />
        <label for="floatingPassword">Country*</label>
        <br />
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control floatingPassword"
          placeholder="Tittle Event"
          bind:value={$userRealTime.jobtittle}
        />
        <label for="floatingPassword">Jobtittle*</label>
        <br />
      </div>
      <div class="form-floating">
        <input
          type="text"
          class="form-control floatingPassword"
          placeholder="Country"
          bind:value={$userRealTime.company}
        />
        <label for="floatingPassword">Company*</label>
        <br />
      </div>
    </div>
    <div class="containerInputs"></div>

    <div class="btnContainer">
      <button class="actionBtn" on:click={updateData}>Save Changes</button>
    </div>
  </div>
</div>
{#if $isAlertOn}
  <AlertModal/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .PrincipalContainer {
    width: 100%;
    height: auto;
    min-height: 200px;
    display: flex;
  }
  .imgContainer {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    color: rgba(0, 0, 0, 0.685);
  }
  .updateImageContainer {
    width: 21%;
    height: 45%;
    border-radius: 50%;
    background-color: #0000007e;
    position: absolute;
    z-index: 888;
    opacity: 0;
  }
  .updateImageContainer:hover {
    opacity: 1;
    cursor: pointer;
  }
  .editBtnContainer {
    cursor: pointer;
    color: white;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 320px;
    height: 320px;
    border-radius: 50%;
    background-size: cover;
    object-fit: cover;
  }
  .circle {
    background-color: #dddcdc;
    width: 320px;
    height: 320px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .infoContainer {
    width: 70%;
    display: flex;
    flex-direction: column;
    padding: 40px 10px;
  }
  .containerInputs {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
  }
  .form-floating {
    width: 30%;
    height: auto;
    margin: 15px 10px;
  }
  .form-control {
    width: 100%;
  }
  .btnContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .actionBtn {
    width: 40%;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }
  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .imgContainer {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .updateImageContainer {
      width: 25%;
      height: 20%;
      border-radius: 50%;
      background-color: #00000000;
      position: absolute;
      z-index: 888;
      opacity: 1;
    }
    .editBtnContainer {
      cursor: pointer;
      color: black;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      padding-top: 20px;
    }
    .containerInputs {
      padding-left: 20px;
    }
    .form-floating {
      width: 45%;
      height: auto;
      margin: 5px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .PrincipalContainer {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .imgContainer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 200px;
      height: 200px;
      object-fit: cover;
    }
    .circle {
      width: 200px;
      height: 200px;
    }
    .updateImageContainer {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0);
      position: absolute;
      z-index: 99;
      opacity: 1;
    }
    .editBtnContainer {
      cursor: pointer;
      color: black;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      padding-top: 20px;
    }
    .infoContainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 10px;
    }
    .containerInputs {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .form-floating {
      width: 100%;
      height: auto;
      margin: 0;
    }
    .btnContainer {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .actionBtn {
      width: 100%;
    }
  }

  /* End of the section */
</style>
